export default "__VITE_ASSET__BALAJ$Ts__"